module.exports = __webpack_public_path__ + "static/media/txtfile.036239a8.png";